import {IStorageService} from "./IStorageService.ts";
import {StorageKeys} from "../consts/storageKeys.ts";

export class SessionStorageService implements IStorageService {
    getItem<T>(key:StorageKeys){
        const sessionStorageItemString = sessionStorage.getItem(key);
        if (sessionStorageItemString)
            return JSON.parse(sessionStorageItemString) as T;
        return null;
    }
    setItem<T>(key:StorageKeys, value: T) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    removeItem(key: StorageKeys): void {
        sessionStorage.removeItem(key);
    }
}